import * as Sentry from '@sentry/vue'
import type { RipType } from '@/components/release-in-progress/types'
import { RELEASE_IN_PROGRESS_SENTRY_EVENT_TYPE, RELEASE_IN_PROGRESS_SENTRY_MESSAGE } from '@/utils/constants/sentry'

const reportedPageStates = new Set<string>()

export const clearReleaseInProgressSentryState = () => reportedPageStates.clear()

export const useReleaseInProgressSentry = (getPage: () => RipType) => {
  const route = useRoute()
  const { locale } = useI18n()

  const reportReleaseInProgress = () => {
    if (!import.meta.client) return

    const page = getPage()
    const pagePath = route.path
    const pageState = `${page}:${pagePath}`

    if (reportedPageStates.has(pageState)) return

    reportedPageStates.add(pageState)

    Sentry.captureMessage(RELEASE_IN_PROGRESS_SENTRY_MESSAGE, {
      level: 'warning',
      fingerprint: [RELEASE_IN_PROGRESS_SENTRY_EVENT_TYPE, page],
      tags: {
        event_type: RELEASE_IN_PROGRESS_SENTRY_EVENT_TYPE,
        rip_locale: locale.value,
        rip_page: page,
        rip_route: pagePath
      }
    })
  }

  watch([getPage, () => route.path], reportReleaseInProgress, { immediate: true })
}
